import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';

/**
 * Tramo de venta con su categoría.
 *
 * El proveedor no se pide: siempre es Arcor y lo pone el backend desde
 * Furniture::PROVEEDOR_CARDCODE.
 */
export default WithApp(function ModalFurnitureCategory(props) {
  const category = props.model;

  return (
    <Modal
      title="Rango venta de mueble"
      model={category}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/furniture-sales-category"
    >
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={category?.description || ''}
        helperText="Nombre de la categoría, por ejemplo Oro o Plata"
        required
      />

      <TextField
        label="Venta desde"
        type="number"
        name="sales_min"
        margin="normal"
        fullWidth
        defaultValue={category?.sales_min ?? 0}
        inputProps={{ min: 0, step: '0.01' }}
        required
      />

      {/* Vacío = sin tope, para la categoría más alta */}
      <TextField
        label="Venta hasta"
        type="number"
        name="sales_max"
        margin="normal"
        fullWidth
        defaultValue={category?.sales_max ?? ''}
        inputProps={{ min: 0, step: '0.01' }}
        helperText="Dejar vacío si es la categoría más alta, sin tope"
      />
    </Modal>
  );
});
